export const SIGN_IN = "SIGN_IN";
export const RESTAURANT_CONFIG = "RESTAURANT_CONFIG";
export const SIGN_OUT = "SIGN_OUT";
export const AUTH_ERROR = "AUTH_ERROR";
